import React, { useEffect } from 'react';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';

declare const window: WindowTypes;

export default function CheckPermissionNotification() {
  const waitCheckPermission = async () => {
    try {
      const isFlagEmarsys = getFlagValue(FLAG_ENUM.EMARSYS);
      const isFlagEmarsysWebPush = getFlagValue(FLAG_ENUM.EMARSYS_WEB_PUSH);
      if (
        !isFlagEmarsys ||
        !isFlagEmarsysWebPush ||
        typeof WebEmarsysSdk !== 'object' ||
        typeof WebEmarsysSdk?.isSubscribed !== 'function'
      )
        return;
      const isSubscribed = await WebEmarsysSdk?.isSubscribed();
      const alreadyDenied = Notification.permission === 'denied';
      if (!isSubscribed && !alreadyDenied && typeof WebEmarsysSdk?.subscribe === 'function') {
        console.log('EVENT: subscribe');
        WebEmarsysSdk.subscribe()
          .then(() => {
            console.log('EVENT: successfully subscribed');
          })
          .catch(() => {
            console.log('EVENT: failed to subscribe');
          });
      }
    } catch {
      console.log('EVENT: failed to subscribe');
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', waitCheckPermission);
    window.addEventListener('touchstart', waitCheckPermission);
    document.addEventListener('click', waitCheckPermission);
    return () => {
      window.removeEventListener('mousemove', waitCheckPermission);
      window.removeEventListener('touchstart', waitCheckPermission);
      document.removeEventListener('click', waitCheckPermission);
    };
  }, []);

  return <div />;
}
